<template>
  <!-- <el-scrollbar class="main"> -->
  <div class="jf-content">
    <div class="main-content">
      <div class="main-left">
        <!-- <div class="ai-results-title">{{ allKey }}</div> -->
        <div class="ai-results-loading" v-if="loading">
          <!-- <div class="ai-results-loading-icon">搜索中...</div> -->
          <div class="ai-results-loading-text">
            <div class="process">
              <div class="process-root">
                <div class="process-root__bar">
                  <span class="step" :style="{ width: stepWidth }"></span>
                  <!-- step-0未开始  step-1进行中  step-2已完成 -->
                  <div class="process-root__item" v-for="(item, index) in processBarData" :key="'process-' + index">
                    <i v-if="currentStep > index" :key="index">
                      <lottie :options="completeIconOptions" :height="20" :width="20" @animCreated="handleAnimation" />
                    </i>
                    <i v-else-if="currentStep == index">
                      <lottie :options="runningIconOptions" :height="20" :width="20"
                        @animCreated="runningIconAnimation" />
                    </i>
                    <i v-else></i>
                    <span :class="currentStep > index ? 'activeText' : ''">{{
                      item.name
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ai-results ref="aiResults" :isSkeleton="isSkeleton" :isNodata="isNodata" :EventList="eventList"
          :Article="article" :AiResultData="aiResultData" :CommunityData="CommunityData"
          :CrossCommunity="CrossCommunity" :ClassifyEventTime="ClassifyEventTimeData"
          :NoContextError="noContextError"></ai-results>
      </div>
      <!-- <div class="main-right" v-loading="hotLoading">
        <ai-hotList ref="aiHotList" :hotList="hotList"></ai-hotList> -->
      <!-- <ai-results-list
          ref="airRelated"
          :hotList="relatedReportsList"
        ></ai-results-list> -->
      <!-- </div> -->
    </div>
  </div>
  <!-- </el-scrollbar> -->
</template>

<script>
import eventBus from "@/pages/EventBus.js";
// let moment = require("moment");
import AiResultsList from "@/pages/views/project/AiResultsList.vue";
import AiResults from "@/pages/views/project/AiResults.vue";
import AiHotList from "@/pages/views/project/AiHotList.vue";
import { removeRepeat } from "@/filters/index.js";
import { mapState } from "vuex";

import completeIcon from "@/assets/completeIcon.json";
import runningIcon from "@/assets/runningIcon.json";

import {
  GetArticleNameExtraction,
  GetRelations,
  NewGetEvents,
  NewGetGetSummary,
  GetRelatedArticles,
  GetClueArticleList,
  Post2Samba,
  GetEdges,
  CrossCommunity,
  ClassifyEventTime,
  GetEntities,
  GetGraphsFromEntities,
} from "@/api/index.js";

export default {
  props: {
    formSearch: {
      type: Object,
      required: true,
    },
    semantics: {
      type: Boolean,
    },
    retrieval: {
      type: Boolean,
    },
    coreNum: {
      type: String,
    },
    aiSetForm: {
      type: Object,
    },
  },
  components: {
    AiResults,
    AiHotList,
    AiResultsList,
  },
  data() {
    return {
      allKey: "",
      dataObj: {},
      isSkeleton: true,
      timer: null,
      stepInterval: 500,
      currentStepIndex: 0,
      stepsList: [
        "分析问题",
        "梳理脉络",
        "编写总结",
        "相关组织",
        "相关人物",
        "涉及地域",
      ],
      activeSteps: 1,
      loading: false,
      hotLoading: true,
      hotList: [],
      eventList: [], // 事件脉络
      CommunityData: [], // 社区摘要

      article: "", // 智能总结
      getSummaryArticle: false,
      aiResultData: {
        organizationLoading: true,
        personLoading: true,
        organization: {}, // 相关组织
        person: {}, // 相关人物
        place: {}, // 匹配地域
        organizationTable: [], // 相关组织表格
        personTable: [], // 相关人物表格
      },
      nameList: [],
      isNodata: true,
      percentage: 0,

      summaryData: [], // 总结数据
      relatedReportsList: [],

      completeIconOptions: { animationData: completeIcon, loop: false },
      runningIconOptions: { animationData: runningIcon, loop: true },

      currentStep: -1, // 当前步骤，实际从0开始为第一个步骤
      processBarData: [
        {
          name: "分析问题",
        },
        {
          name: "编写总结",
        },
        {
          name: "梳理脉络",
        },
        {
          name: "信息图谱",
        },
      ],
      CrossCommunity: {},
      ClassifyEventTimeData: [],
      ClassifyEventTimeDataFlag: false,
      vectorScore: 0.5,

      noContextError: false,

      entitiesData: "", // 实体关系
    };
  },
  mounted() {
    // this.init();
    // 通过事件总线监听消息
    eventBus.$on("againGetGraph", (vectorScore) => {
      this.vectorScore = vectorScore;
      this.fnCrossCommunity();
    });
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    clearInterval(this.timer);
  },
  computed: {
    // ...mapState(["signalRConnection"]),
    html() {
      return this.md.render(this.markdown);
    },

    stepWidth() {
      // console.log(this.processBarData.length);
      if (this.currentStep >= this.processBarData.length) {
        return 100 + "%";
      } else {
        return (this.currentStep - 1) * 33.3 + 16.6 + "%";
      }
    },
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.setSpeed(1);
    },
    runningIconAnimation: function (anim) {
      this.anim = anim;
      this.anim.setSpeed(0.5);
    },
    /**
     * @func 获取原始事件脉络
     */
    fnNewGetEvents() {
      this.hotLoading = true; // 右侧热点报道loading

      this.loading = true;
      this.currentStep = 1;

      let params = {
        keywords: [
          {
            field: "",
            word: this.formSearch.allKey,
            andOrNot: 0,
          },
        ],
        date: {
          from: this.formSearch.time[0],
          to: this.formSearch.time[1],
        },
        groupArticletypes: this.formSearch.groupArticletypes,
        paggIndex: 1,
        pageSize: 50,
        channelId: 0,
      };

      // groupArticletypes数组遍历查找是否存在373179
      let flag = false;
      for (let i = 0; i < this.formSearch.groupArticletypes.length; i++) {
        if (this.formSearch.groupArticletypes[i] === 373179) {
          flag = true;
          break;
        }
      }
      if (flag) {
        params.groupArticletypes = params.groupArticletypes.filter(
          (item) => item !== 373179
        );
        params.channelId = 373179;
      }

      NewGetEvents(params)
        .then((res) => {
          if (res.data.eventList.length > 0) {
            this.activeSteps = 2;
            this.percentage = 1;

            this.coreWords = res.data.coreWords;

            this.eventList = res.data.eventList.filter(
              (item) => item.summary && item.summary.trim() !== ""
            );
            // console.log(res.data.eventList, 'res.data.eventList')
            let hotListData = [...this.eventList];

            // 截取前10条数据
            hotListData = hotListData.slice(0, 10);

            // 修改hotListData中的名称为aid
            this.hotList = hotListData.map((item) => {
              return {
                articlesequenceid: item.id,
                title: item.title,
                updatetime: item.date,
              };
            });

            this.hotLoading = false;

            // 遍历this.hotList中的articlesequenceid 全部放到数组中
            let aidList = this.hotList.map((item) => item.articlesequenceid);
            // 转换数组中的值为字符串，用;连接
            aidList = aidList.join(";");

            // GetClueArticleList(aidList)
            //   .then((res) => {
            //     this.hotList = res.data.map((item) => {
            //       return {
            //         ...item,
            //         class1: item.class1,
            //       };
            //     });
            //     // this.hotList degree 排序
            //     this.hotList.sort((a, b) => {
            //       return b.degree - a.degree;
            //     });
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //   });

            this.fnGetEntities();

            this.fnGetRelatedArticles();
            this.fnNewGetGetSummary();
          } else {
            this.coreWords = res.data.coreWords;
            this.sendLog();

            this.$message({
              message: "暂无脉络数据，请试试其他关键词分析",
              type: "warning",
            });
            setTimeout(() => {
              // 通过eventBus，调用父组件的函数
              eventBus.$emit("backHome");
            }, 500);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * @func 获取事件总结
     */
    fnNewGetGetSummary() {
      this.getSummaryArticle = false;
      // console.log(this.article);
      let data = {
        question: this.formSearch.allKey,
        allEvents: this.eventList,
      };
      NewGetGetSummary(data)
        .then((res) => {
          if (!this.noContextError) {
            this.currentStep++;
          } else {
            this.currentStep++;
            this.processBarData.length = 2;
          }

          this.article = res.data;
          this.getSummaryArticle = true;
          // this.getOrganization();

          // 最后一步结束star
          this.handleComplete();
          // 最后一步结束end

          // 先走完再替换人名，data-sentence里面的内容不替换
          GetArticleNameExtraction({ article: res.data }).then((res) => {
            if (res.data.length > 0) {
              let replacedText = this.article;
              // 将所有具有 data-sentence 属性的标签的内容提取出来，并用占位符替换
              const dataSentencePattern =
                /<[^>]*\bdata-sentence\b[^>]*>(.*?)<\/[^>]*>/gi;
              let dataSentenceMatches = [];
              replacedText = replacedText.replace(
                dataSentencePattern,
                (match) => {
                  dataSentenceMatches.push(match);
                  return `__DATA_SENTENCE_PLACEHOLDER_${dataSentenceMatches.length - 1
                    }__`;
                }
              );

              // 对剩余文本进行关键词替换
              res.data.forEach((keyword) => {
                const url = "https://baike.baidu.com/item/" + keyword;
                const regex = new RegExp(keyword, "g"); // 创建一个全局的正则表达式
                replacedText = replacedText.replace(
                  regex,
                  `<a target="_blank" href="${url}">${keyword}</a>`
                );
              });

              // 恢复具有 data-sentence 属性的标签的内容
              dataSentenceMatches.forEach((dataSentence, index) => {
                const placeholder = `__DATA_SENTENCE_PLACEHOLDER_${index}__`;
                replacedText = replacedText.replace(placeholder, dataSentence);
              });
              // console.log(this.article); // 输出替换后的文本
              this.article = replacedText;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * @func 相关事件
     */
    fnGetRelatedArticles() {
      // console.log(this.eventList[0].id);
      let params = {
        date: {
          from: this.formSearch.time[0],
          to: this.formSearch.time[1],
        },
        groupArticletypes: this.formSearch.groupArticletypes,
        emotion: null,
        keywords: [
          {
            field: "",
            word: "",
            andOrNot: 0,
          },
        ],
        orderBy: "score desc",
        articleids: [this.eventList[0].id],
        pageIndex: 1,
        pageSize: 10,
      };
      GetRelatedArticles(params)
        .then((res) => {
          this.relatedReportsList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.hotLoading = false;
        });
    },
    /**
     * @func 获取相关组织跟表格
     */
    getOrganization() {
      // console.log("@@@@", "获取相关组织跟表格");
      GetRelations(this.eventList, "org.nt", this.formSearch.allKey)
        .then((res) => {
          // this.currentStep++;

          this.aiResultData.organizationLoading = false;
          this.aiResultData.organization = res.data.relation;
          this.aiResultData.organizationTable = this.getMergelsit(
            this.eventList,
            res.data.table
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * @func 获取人物数据跟表格
     */
    getRelations() {
      GetRelations(this.eventList, "person.nr", this.formSearch.allKey)
        .then((res) => {
          // this.currentStep++;

          this.aiResultData.personLoading = false;
          this.aiResultData.person = res.data.relation;
          this.aiResultData.personTable = this.getMergelsit(
            this.eventList,
            res.data.table
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getMergelsit(list, obj) {
      const resultMap = {};
      list.forEach((item) => {
        if (obj[item.id]) {
          obj[item.id].forEach((val) => {
            if (val) {
              if (!resultMap[item.id]) {
                resultMap[item.id] = {
                  organizationName: val,
                  summary: item.summary,
                  url: item.url,
                  id: item.id,
                };
              } else {
                resultMap[item.id].organizationName += `, ${val}`;
              }
            }
          });
        }
      });
      return Object.values(resultMap);
    },

    /**
     * TODO 解放日报拆分流程-获取关系实体
     */
    fnGetEntities() {
      return new Promise((resolve, reject) => {
        let data = {
          question: this.formSearch.allKey,
          allEvents: this.eventList,
        };
        GetEntities(0, data)
          .then((res) => {
            // 判断res.data 是否为数组
            if (Array.isArray(res.data)) {
              // this.entities = res.data;
              this.entitiesData = res.data;
              this.fnGetGraphsFromEntities();
              resolve(); // 成功时调用 resolve
            } else {
              // 如果不是数组，则路由跳转 /, 并提示错误
              eventBus.$emit("backHome");
              this.$message({
                message: "大模型提取知识图谱失败，没有社区",
                type: "warning",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    /**
     * TODO 获取社区摘要-凡解放拆分-新接口
     */
    fnGetGraphsFromEntities() {
      this.CommunityData = [];
      let data = {
        question: this.formSearch.allKey,
        allEvents: this.entitiesData,
      };
      GetGraphsFromEntities(
        this.aiSetForm.minNodeNumber,
        this.aiSetForm.minSimilarity,
        this.aiSetForm.minVectorSimilarity,
        0,
        this.aiSetForm.filterMaxNodeLink,
        data
      )
        .then((res) => {
          this.CommunityData = res.data;

          this.fnCrossCommunity();
          // this.fnClassifyEventTime();

          let newArry = JSON.parse(JSON.stringify(res.data))
          const allNodes = newArry.flatMap((item, index) => (item.nodes || []).map(node => ({ ...node, _sourceIndex: index })));

          const mergedNodes = Object.values(
            allNodes.reduce((acc, node) => {
              const { id, description, _sourceIndex, ...rest } = node;

              if (acc[id]) {
                if (description) {
                  acc[id].description = acc[id].description
                    ? `${acc[id].description}\n${description}`
                    : description;
                }
                acc[id].sourceIndex = _sourceIndex;
              } else {
                acc[id] = { ...rest, id, description, sourceIndex: _sourceIndex };
              }

              return acc;
            }, {})
          );

          this.ClassifyEventTimeData = mergedNodes;

          // console.log(mergedNodes, 'res.data;')
          this.ClassifyEventTimeDataFlag = true;

          this.handleComplete()
        })
        .catch((err) => {
          console.warn(err);
          this.eventList = null;
          this.$message({
            message: "暂无社区脉络，请试试其他关键词分析",
            type: "warning",
          });
        });
    },

    startTimer() {
      this.timer = setInterval(() => {
        if (this.percentage < 99) {
          this.percentage++;
        } else {
          // 所有步骤都已完成，可以清除定时器
          clearInterval(this.timer);
        }
      }, this.stepInterval);
    },
    /**
     * 获取信息图谱
     */
    getEdges() {
      GetEdges(this.eventList)
        .then((res) => {
          this.activeSteps = 4;
          this.percentage = 100;
          clearInterval(this.timer);
          this.aiResultData.wordLoading = false;
          this.aiResultData.wordRelation = res.data.default;
          this.screenWordRelation = res.data;
          this.$emit("searchComplete"); // 搜索完成
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * TODO 获取新的信息图谱
     */
    fnCrossCommunity() {
      // console.log("@@vectorScore",this.vectorScore)
      // 遍历出this.CommunityData数组中 vectorScore值0.5以上的数据
      let newData = this.CommunityData.filter((item) => {
        return item.vectorScore >= this.vectorScore;
      });
      // console.log(newData)
      CrossCommunity(newData)
        .then((res) => {
          this.CrossCommunity = res.data;

          this.handleComplete();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * TODO 获取新的事件脉络
     */
    fnClassifyEventTime() {
      this.ClassifyEventTimeDataFlag = false;
      let data = {
        question: this.formSearch.allKey,
        graphs: this.CommunityData,
      };
      ClassifyEventTime(data)
        .then((res) => {
          // console.log("新的脉络", res);

          this.ClassifyEventTimeData = res.data;
          this.ClassifyEventTimeDataFlag = true;

          // 最后一步结束star
          this.handleComplete();
          // 最后一步结束end
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * TODO 处理最后一步,流程结束
     */
    handleComplete() {
      if (this.getSummaryArticle && this.ClassifyEventTimeDataFlag) {
        this.currentStep = 4;
        this.$emit("searchComplete"); // 搜索完成
        if (this.isSkeleton) {
          this.sendLog(); // 发送日志
        }
        this.isSkeleton = false;
      }
    },
    /**
     * 发送日志文件到服务器
     */
    sendLog() {
      let params = {
        question: this.formSearch.allKey,
        coreWords: this.coreWords,
        topics: this.eventList,
        graphes: this.CommunityData,
      };
      Post2Samba(params)
        .then((res) => {
          // console.log(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.jf-content {
  width: 1240px;
  height: calc(100% - 60px);
  overflow-y: auto;
  margin: 0 auto;

  .main-content {
    display: flex;
    justify-content: space-between;

    .main-left {
      flex: 1;

      background: #fff;
      border-radius: 6px;

      .ai-results-title {
        font-weight: 600;
        font-size: 36px;
        color: #222222;
        margin-bottom: 20px;
        padding-left: 36px;
        margin-top: 30px;
      }

      .ai-results-loading {
        border-bottom: 1px solid #ebeef5;
        margin-top: 30px;
        padding-bottom: 20px;
        padding-left: 36px;

        .ai-results-loading-icon {
          background: url("../../../assets/jfrb/search.png") no-repeat left;
          padding-left: 24px;
          font-weight: 600;
          font-size: 16px;
          color: #333333;
        }

        .ai-results-loading-text {
          margin-top: 15px;

          .ai-steps {
            ::v-deep .is-success {
              color: var(--brand);
              border-color: var(--brand);
            }

            ::v-deep .is-success {
              font-size: 14px;
              color: var(--brand);

              .my-progress {
                display: none;
              }
            }

            ::v-deep .is-wait {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.6);

              .my-progress {
                display: none;
              }
            }

            ::v-deep .is-process {
              border-color: #fff !important;
              line-height: 23px !important;

              .el-progress-circle {
                width: 30px !important;
                height: 30px !important;
              }

              .el-progress__text {
                font-size: 10px !important;
              }
            }

            // ::v-deep .el-step__title.is-process .my-progress{
            //   content: " ";
            //   background: url("../../../assets/loading.gif") no-repeat;
            //   display: inline-block;
            //   vertical-align: middle;
            //   width: 25px;
            //   height: 25px;
            //   color: var(--brand);
            //   background-size: contain;
            // }
          }
        }
      }
    }

    .main-right {
      width: 350px;
      margin-left: 25px;
    }
  }
}

.tag {
  background: #c0c0c0;
  border-radius: 50%;
  padding: 2px 3px;
  text-align: center;
  color: #fff;
  margin-right: 6px;
  font-size: 12px;
}

.no-eventList {
  width: 100%;
  line-height: 200px;
  text-align: center;
  color: var(--text-3);
}

.process {
  width: 70%;
  height: 90px;
  margin: 0 auto;

  &-root {
    &__bar {
      top: 20px;
      height: 3px;
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      background: #f2f4f7;

      .step {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--brandDark);
        transition: width 0.5s, height 0.1s;
      }
    }

    &__item {
      border-radius: 50%;
      background: var(--border-color);
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      i {
        width: 20px;
        height: 20px;
        display: block;
        background: url("~@/assets/step-0.png") no-repeat;
        background-size: 100%;
      }

      span {
        position: absolute;
        top: 100%;
        white-space: nowrap;
        color: #98a2b3;
        margin-top: 15px;
        line-height: 1.68;
        font-size: 14px;
      }
    }
  }
}

.step-running {
  i {
    width: 20px;
    height: 20px;
    display: block;
  }

  span {
    color: var(--brandDark);
  }
}

.step-complete {
  i {
    width: 20px;
    height: 20px;
    display: block;
  }

  span {
    color: var(--brandDark);
  }
}

.process-root__item .activeText {
  color: var(--brand);
}
</style>
